module.exports = __webpack_public_path__ + "media/2_2-10.3d2a7606.mp3";